<style>
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #606266;
  }
  .format-pre pre {
    font-size: 16px;
  }  
  .SelectSize {
      background-color: #007bff;
      border: solid #007bff 2px;
      color: white;
  }  
  .NotSelectSize {
      background-color: #c0c4cc59;
      border: solid #c0c4cc59 2px;
      color: black;
  }  
  .background-info{
    background-color: #d1ecf1;
    color: #0c5460;
  }
</style>
<template>
  <div class="card card-flush" style="font-size: 1rem">
    <div class="card-header border-0 my-3" style="min-height: 0px">
      <div class="card-toolbar">
        <div>
          <role-view :roles="['admin']">
            <i class="fa fa-angle-left mr-2" style=" cursor: pointer; font-size: 30px;color: #1e5c9e; vertical-align: middle;" @click="callCustomerPartner"></i>
            &nbsp;&nbsp;    
          </role-view>        
          <el-input
            size="medium"
            placeholder="ค้นหา"
            prefix-icon="el-icon-search"
            v-model="search"
            clearable
            style="width: 200px;"
          >
          </el-input>  
        </div>   
        <div style="margin-left: 20px;">          
             <el-dropdown trigger="click">
              <button class="btn btn-primary btn-sm">
                <span class="dropdown-toggle">
                  ซ่อน/แสดงคอลัมน์
                </span>
              </button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item style="margin-left: 0rem !important;"  v-bind="$attrs"><el-checkbox v-model="showAVG3M">AVG3M</el-checkbox> </el-dropdown-item>
                  <el-dropdown-item style="margin-left: 0rem !important;"  v-bind="$attrs"><el-checkbox v-model="showStockDays">Stock(วัน)</el-checkbox> </el-dropdown-item>
                  <el-dropdown-item style="margin-left: 0rem !important;"  v-bind="$attrs"><el-checkbox v-model="showStock2S">สต็อก 2S</el-checkbox> </el-dropdown-item>
                  <el-dropdown-item  style="margin-left: 0rem !important;"  v-bind="$attrs"><el-checkbox v-model="showMargin">กำไร</el-checkbox> </el-dropdown-item>
                  <el-dropdown-item  style="margin-left: 0rem !important;"  v-bind="$attrs"><el-checkbox v-model="showPriceInc">ราคาขาย (Inc.Vat)</el-checkbox> </el-dropdown-item>                
                </el-dropdown-menu>
              </template>
            </el-dropdown> 
         </div> 
        <div style="margin-left: 20px;">
          <span style="font-weight: 500; font-size: 14px; color: #606266;"></span>&nbsp;&nbsp;<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">แสดง{{checkName}}</el-checkbox>          
        </div>
        <!-- <div style="margin-left: 10px;">
          <span style="font-weight: 500; font-size: 14px; color: #606266;"></span>&nbsp;<el-checkbox v-model="showStock2S">แสดงสต็อก 2S</el-checkbox>          
        </div>
        <div style="margin-left: 10px;">
          <span style="font-weight: 500; font-size: 14px; color: #606266;"></span>&nbsp;<el-checkbox v-model="showMargin">แสดงกำไร</el-checkbox>          
        </div>     -->
        <!-- <div style="margin-left: 10px;">
          <span style="font-weight: 500; font-size: 14px; color: #606266;"></span>&nbsp;<el-checkbox v-model="checkPriceType" @change="handlePriceViewChange">ราคา{{priceView}}</el-checkbox>          
        </div>    -->
        <div style="margin-left: 10px;">
          <span style="font-weight: 500; font-size: 14px; color: #606266;"></span>&nbsp;<el-checkbox v-model="showMinimal">แสดงแบบ minimal</el-checkbox>          
        </div> 
               
      </div>
      <div class="card-title ">
        <!--begin::Search-->
        <!-- <el-input placeholder="Please input" v-model="search"></el-input> -->
        <div class="d-flex align-items-center  ">
          <role-view roles="admin">
             <button            
              class="btn btn-sm btn-primary py-3 px-5 me-3"
              @click="navigateToCreateCampaign"
            >
              สร้างแคมเปญ
            </button>
            <button            
              class="btn btn-sm btn-primary py-3 px-5 me-3"
              @click="navigateToSetProduct"
            >
              กำหนดสินค้าพาร์ทเนอร์
            </button>
            <button            
              class="btn btn-sm btn-primary py-3 px-5 me-3"
              @click="setMarkupClickHandler"
              :disabled="this.products.filter((p) => p.isSelected == true).length == 0"
            >
              กำหนดกำไร
            </button>
          </role-view>         
          <role-view :roles="['user', 'manager', 'owner']">     
          <!-- <div v-if="currentUser.partnerCode == 'H0026'||currentUser.partnerCode == 'A0273' || currentUser.partnerCode == 'J0142'"> -->
          <div> 
            <button
              class="btn btn-sm background-info py-3 px-5 me-3"
              @click="sellRequestClickHandler"
            >
              เสนอราคา
            </button> 
          </div>     
          <button
            class="btn btn-sm btn-light-info py-3 px-5 me-3"
            @click="transferBookClickHandler"
          >
            จองย้าย
          </button>            
          <button
            class="btn btn-sm btn-light-primary py-3 px-5 me-3"
            @click="orderClickHandler"
          >
            เปิดบิล
          </button>
          </role-view>
          <!-- <role-view roles="admin">
            <button
              class="btn btn-sm btn-light-primary py-3 px-5 me-3"
              @click="returnClickHandler"
              :disabled="this.products.filter((p) => p.isSelected == true).length == 0"
            >
              คืนสินค้า
            </button>
          </role-view> -->

          <download-excel
            :class     = "btnExcelClass"
            :style    = "btnExcelStyle"
            :data     = "products"
            :name     = "excelFileName"
            :meta     = "excelMeta"
            :param    = "excelParam"
            :columnName = "excelColumnName"
            :titleSheet = "excelTitleSheet">
            <i class="fa fa-file-excel"></i> Excel
          </download-excel>

          <!-- <span class="svg-icon svg-icon-1 position-absolute ms-6">
            <inline-svg src="/media/icons/duotune/general/gen021.svg" />
          </span>
          <inputz
            type="text"
            v-model="search"
            @input="searchItems()"
            class="form-control form-control-solid w-250px ps-15"
            placeholder="ค้นหา"
          /> -->
        </div>
        <!--end::Search-->
      </div>

     
    </div>
    <div class="card-body pt-0 row">
      
        <!-- <div class="card"> -->
          <!-- <div class="col-xl-2 col-md-1"> -->
          <div class="row">
            <div class="col-xl-2 col-md-2"> 
              <el-tooltip
                class="item"
                effect="dark"
                :content="!categoryShow?'Show':'Hide'"
              >              
                <button class="btn btn-link" @click="setColumn"><i :class="!categoryShow?'fa fa-indent':'fa fa-outdent'" style="cursor: pointer; font-size: 20px; color: rgb(30, 92, 158); vertical-align: middle;"></i>หมวดสินค้า </button>
              </el-tooltip> 
            </div>
            <div class="col-xl-10  col-md-10">
              <div class="col-12">
                <div style="padding: 4px; text-align: center; float: left;" >
                    <label style="font-weight: bold;">Size : </label>&nbsp;
                    <span v-bind:class="[selectedSize == 'All' ? 'SelectSize' : 'NotSelectSize']" style="border-radius: 15px; cursor: pointer; padding: 2px 8px;" @click="selectedSizeHandler('All')">
                        <span style="font-size: 15px; padding: 5px 0px;">All</span>
                    </span>
                </div>
                <div v-for="size in sizes" :key="size.id" style="padding: 4px; text-align: center; float: left; margin-bottom: 0px;">
                    <span style="border-radius: 15px; padding: 2px 8px; cursor: pointer;" v-bind:class="[selectedSize == size.name ? 'SelectSize' : 'NotSelectSize']" @click="selectedSizeHandler(size.name)">
                        <span style="font-size: 15px; padding: 5px 0px;">{{size.name}}</span>
                    </span>
                </div>                                                                                                       
              </div>
            </div>
            <!-- <br>
            <br> -->
            <div class="row justify-content-end">
              <!-- <div class="col-2" v-if="categoryShow" ></div> -->
              <div class="col-4" v-if="categoryShow" style="padding: 4px;"><el-checkbox v-model="selectedProductsAll" size="large" label="เลือกสินค้าทั้งหมด" @change="selectProductAllHandler" /></div>
              <div class="col-6" v-else style="padding: 4px;"><el-checkbox v-model="selectedProductsAll" size="large" label="เลือกสินค้าทั้งหมด" @change="selectProductAllHandler" /></div>
              <div class="col-4" style="text-align: right;">
                แสดงราคา/{{priceView}} &nbsp;
                <el-switch
                  v-model="checkPriceType"            
                  @change="handlePriceViewChange"
                >
                <!--  active-color="#13ce66"
                  inactive-color="#b7b8bb"  -->
                </el-switch>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div class="col-2" style="text-align: right;"><strong style="color: #606266;">
                
                จำนวนที่เลือก : </strong><strong style="color: red;">{{ countProductSelected }}</strong><strong style="color: #606266;"> รายการ</strong>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div v-if="categoryShow"  class="col-xl-2 col-md-1">
            <ul class="list-group" style="height: calc(100vh - 19rem); overflow: scroll; cursor: pointer;">
              <li class="list-group-item list-group-item-action"
                :class="{active: selectedCategory && selectedCategory.productCategoryCode == category.productCategoryCode}"
                @click="selectCategoryHandler(category)" 
                v-for="category in productCategoryList.filter(c => c.proCateIsSelling)" 
                :key="category.productCategoryCode">
                {{category.productCategoryName}}
              </li>
            </ul>
          </div>
        <!-- </div> -->
      <div :class="categoryShow?'col-xl-10  col-md-10':'col'">       
        
        <!-- @selection-change="selectProductHandler" -->
        <el-table
          :data="tableProducts"
          style="width: 100%"
          ref="productStockTable"
          :height="tableHeight"
          :cell-style="{'padding-top': '10px', 'padding-bottom': '10px' }"
          show-summary
          :summary-method="summary"   
          id="out-table"   
        >
          <el-table-column width="45">
            <template #default="scope">
              <el-checkbox v-model="scope.row.isSelected" size="large" />
            </template>
          </el-table-column>
          <!-- <el-table-column type="selection" width="45" :selectable="canSelectRow"> </el-table-column> -->
          <el-table-column prop="productCode" label="รหัสสินค้า" width="150" v-if="isAdmin"  sortable>
            <template #default="scope">
              <span style="cursor: pointer;" @click="callProductMoveMentAllMonthModal(scope.row)">{{ scope.row.productCode }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="prosizeGroup" label="ขนาด" width="150" v-if="isAdmin"  sortable>
          </el-table-column>           -->

          <el-table-column prop="productName"  label="สินค้า" sortable>
            <template #default="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="getPriceQuanPerPack(scope.row)"
                placement="top"
                :disabled="!scope.row.productIsSteel"
              >              
                <span style="cursor: pointer;" @click="callProductMoveMentAllMonthModal(scope.row)">{{ scope.row.productName }}</span>&nbsp;
              </el-tooltip>
                <span class="text-info">
                  [{{ numberWithCommas(scope.row.productWeight) }} กก.]</span
                >              
            </template>
          </el-table-column>
      
          <el-table-column
            prop="stockQuantity"
            label="คงเหลือ"
            align="right"
            width="130"
            sortable
          >
            <template #default="scope">              
              <!-- <div v-if="this.priceType == 'weight'" >
                <span v-if="scope.row.productWeight >0">
                  {{ numberWithCommas(scope.row.stockQuantity/scope.row.productWeight) }}
                </span>
                <span v-else> - </span>
              </div>      
              <div v-else> -->
              <span v-if="scope.row.stockQuantity > 0">
                {{ numberWithCommas(scope.row.stockQuantity, 0) }}
              </span>
              <span v-else> 0 </span>   
              <!-- </div>   -->
            </template>
          </el-table-column>
          <el-table-column
            prop="stockDays"
            label="อายุสินค้า(วัน)"
             width="120"
            align="right"
            v-if="!showMinimal"
            sortable
          >
            <template #default="scope">
              {{ numberWithCommas(scope.row.stockDays, 0) }}
            </template>
          </el-table-column>
          <el-table-column sortable
            label="AVG3M"
            align="right"
            width="100"
            v-if="showAVG3M && !showMinimal"
            :prop="this.priceType == 'weight'?'avG3MonthW':'avG3MonthQ'">
            <template #default="scope">            
              <div v-if="this.priceType == 'weight'" >{{ numberWithCommas(scope.row.avG3MonthW, 2) }}  </div>
              <div v-else >{{ numberWithCommas(scope.row.avG3MonthQ, 0) }} </div>
            </template>
          </el-table-column>  
          <el-table-column sortable
              label="Stock(วัน)"
              align="right"
              width="115"
              v-if="showStockDays&& !showMinimal"
              :prop="this.priceType == 'weight'?'stockWeightDay':'stockQuanDay'">
              <template #default="scope">                            
                <div v-if="scope.row.stockQuanDay != 99999" >      
                  <div v-if="this.priceType == 'weight'" >{{ numberWithCommas(scope.row.stockWeightDay, 0) }}  </div>
                  <div v-else >{{ numberWithCommas(scope.row.stockQuanDay, 0) }} </div>
                </div>
                <div v-else>
                  <strong class="text-danger">DS</strong>
                </div>
              </template>
            </el-table-column>
          <el-table-column
            prop="stockQuantity2S"
            label="สต็อก 2S"
            align="right"
            width="120"
            sortable
            v-if="showStock2S"
          >
            <template #default="scope">
              <!-- <div v-if="this.priceType == 'weight'" >
                <span v-if="scope.row.productWeight >0">
                  {{ numberWithCommas(scope.row.stockQuantity2S/scope.row.productWeight) }}
                </span>
                <span v-else> - </span>
              </div>      
              <div v-else> -->
              <div v-if="scope.row.stockQuantity2S > 0">                
                <div v-if="scope.row.planFinDate != null && scope.row.planFinDate != '0001-01-01T00:00:00'">
                  <el-tooltip
                  class="item"
                  effect="dark"
                  :content="getPlanFinDate(scope.row)"
                  placement="top"
                  :disabled="!scope.row.productIsSteel"
                  >              
                  <span style="cursor: pointer;">{{ numberWithCommas(scope.row.stockQuantity2S, 0) }} <i class="fas fa-calendar-day"></i></span>
                  </el-tooltip>                     
                </div>
                <div v-else>{{ numberWithCommas(scope.row.stockQuantity2S, 0) }}</div>                
              </div>
              <div v-else>
                <div v-if="scope.row.planFinDate != null && scope.row.planFinDate != '0001-01-01T00:00:00'">
                  <el-tooltip
                  class="item"
                  effect="dark"
                  :content="getPlanFinDate(scope.row)"
                  placement="top"
                  :disabled="!scope.row.productIsSteel"
                  >              
                  <span style="cursor: pointer;">0 <i class="fas fa-calendar-day"></i></span>
                  </el-tooltip>                     
                </div>
                <div v-else>0</div>
              </div>   
              <!-- </div>     -->
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="productWeight"
            label="น้ำหนัก"
            align="right"
            width="110"
            sortable
          >
            <template #default="scope">
              {{ numberWithCommas(scope.row.productWeight) }}
            </template>
          </el-table-column> -->
          <el-table-column
            prop="costPrice"
            label="ราคา 2S"
            align="right"
            width="110"
            sortable
            v-if="showProfit && !showMinimal"
          >
            <template #default="scope">
              <div v-if="scope.row.pricePerWeight > 0">
                <div v-if="this.priceType == 'weight'">
                  <div v-if="scope.row.campaignID > 0">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.campaignConditionShow"
                      placement="top"
                    >
                      <span v-if="scope.row.productWeight >0" style="color: red;">
                        {{ numberWithCommas(scope.row.campaignPrice/scope.row.productWeight) }}
                      </span> 
                      <span v-else> - </span>
                    </el-tooltip>
                    <br>
                    <span v-if="scope.row.productWeight >0" style="font-size: 12px !important; text-decoration: line-through;">
                      {{ numberWithCommas(scope.row.priceStandard/scope.row.productWeight) }}
                    </span>
                    <span v-else> - </span>               
                  </div>
                  <div v-else>
                    <span v-if="scope.row.productWeight >0">
                      {{ numberWithCommas(scope.row.costPrice/scope.row.productWeight) }}
                    </span>
                    <span v-else> - </span>
                  </div> 
                </div>    
                <div v-else>
                  <div v-if="scope.row.campaignID > 0">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.campaignConditionShow"
                      placement="top"
                    >
                      <span style="color: red;">
                        {{ numberWithCommas(scope.row.campaignPrice) }}
                      </span> 
                    </el-tooltip>
                    <br>
                    <span style="font-size: 12px !important; text-decoration: line-through;">
                      {{ numberWithCommas(scope.row.priceStandard) }}
                    </span>               
                  </div>
                  <div v-else>
                    <span>
                      {{ numberWithCommas(scope.row.costPrice) }}
                    </span>
                  </div> 
                </div>   
              </div>
              <div v-else>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="ยังไม่ได้กำหนดราคาฝากขาย"
                    placement="top"
                  >
                  <span>
                    {{ "N/A" }}
                  </span>
                  </el-tooltip>              
              </div>            
            </template>
          </el-table-column>
          <el-table-column
            prop="markupValue"
            label="กำไร"
            align="right"
            width="100"
            sortable
            v-if="showProfit && !showMinimal && showMargin"
          >
            <template #default="scope">
              <span v-if="scope.row.markupValue > 0">
                <div v-if="this.priceType == 'piece' && scope.row.productIsSteel">
                  {{ numberWithCommas(scope.row.markupValue*scope.row.productWeight) }}                  
                  ฿/เส้น
                </div>
                <div v-else>
                  {{ numberWithCommas(scope.row.markupValue) }}
                  {{ scope.row.markupTypeName }}
                </div>  
                
              </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="markupPrice"
            label="ราคาขาย"
            align="right"
            width="110"
            sortable
            v-if="!showMinimal"
          >
            <template #default="scope">
              <div v-if="scope.row.pricePerWeight > 0">
                  <div v-if="this.priceType == 'weight'">
                    <span v-if="scope.row.markupPrice > 0 && scope.row.productWeight >0">
                      {{ numberWithCommas(scope.row.markupPrice/scope.row.productWeight) }}
                    </span>
                    <span v-else> - </span>
                  </div>
                  <div v-else>
                    <span v-if="scope.row.markupPrice > 0">
                      {{ numberWithCommas(scope.row.markupPrice) }}
                    </span>
                    <span v-else> - </span>
                  </div>
              </div>
              <div v-else>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="ยังไม่ได้กำหนดราคาฝากขาย"
                    placement="top"
                  >
                  <span>
                    {{ "N/A" }}
                  </span>
                  </el-tooltip>
              </div>                
            </template>
          </el-table-column>
          <el-table-column
            prop="sellingPrice"
            label="ราคาขาย (Inc.Vat)"
            align="right"
            width="120"
            v-if="showPriceInc"
            sortable
          >
            <template #default="scope">
              <div v-if="scope.row.pricePerWeight > 0">
                <div v-if="this.priceType == 'weight'">
                  <span v-if="scope.row.sellingPrice > 0 && scope.row.productWeight >0">
                    {{ numberWithCommas(scope.row.sellingPrice/scope.row.productWeight) }}
                  </span>
                  <span v-else> - </span>
                </div>
                <div v-else>
                  <span v-if="scope.row.sellingPrice > 0">
                    {{ numberWithCommas(scope.row.sellingPrice) }}
                  </span>
                  <span v-else> - </span>
                </div>
              </div>
              <div v-else>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="ยังไม่ได้กำหนดราคาฝากขาย"
                    placement="top"
                  >
                  <span>
                    {{ "N/A" }}
                  </span>
                  </el-tooltip>
              </div>                
            </template>
          </el-table-column>
          
        </el-table>
        <div class="row mt-3">
          <span style="color: red;" >{{"* DS = Death Stock"}}</span>
      </div>
      </div>
    </div>
    <add-margin-modal ref="addMarginModal" :partnerCode="partnerCode" @refreshdata="clearProductSelected"></add-margin-modal>
    <loading 
      v-model:active="isLoading"
      loader="dots"
      :is-full-page="false"/>
    <!-- <div  v-if="selectedProduct"> -->
      <product-move-ment-all-month-modal
        ref="productMoveMentAllMonthModal"
      ></product-move-ment-all-month-modal>      
    <!-- </div>   -->
  </div>
</template>

<script>
import {ref} from 'vue'
import ApiService from "@/core/services/ApiService";
import AddMarginModal from "@/components/modals/forms/AddMarginModal";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import {role, validateRole} from '@/helpers/role'
import RoleView from '../../components/RoleView.vue';
import Loading from 'vue-loading-overlay';
import Swal from "sweetalert2/dist/sweetalert2.js";
// import DownloadExcel from 'vue-json-to-excel';
import DownloadExcel from '@/components/files/ExportExcel';
import { DateTime } from 'luxon'
import ProductMoveMentAllMonthModal from "../reports/ProductMoveMentAllMonth.vue";
import { array } from 'yup/lib/locale';

export default {
  components: {
    AddMarginModal,
    RoleView,
    Loading,
    DownloadExcel,
    ProductMoveMentAllMonthModal
  },
	created: function () {
		this.currentDate = new Date();
	},  
  data() {
    return {
      windowHeight: window.innerHeight ,
      search: "",
      products: [],
      numPage: null,
      selectedProducts: [],
      selectedProduct:{},
      isLoading: false,
      partner: null,
      checkAll: true,
      isIndeterminate: false,
      checkName: "สต็อก > 0",
      priceView:"เส้น",
      checkState: 1,
      productCategoryList: [],
      selectedCategory: null,
      showAVG3M:false,
      showStockDays:true,
      showStock2S: true,
      showMargin:false,
      showMinimal: false, 
      showPriceInc: true, 
      currentDate : null,
      excelTitleSheet: "", 
      excelFileName: "",
      excelParam: ["productCode","productName","productWeight","stockQuantity","sellingPrice","stockDays","campaignEnd"],
			excelColumnName: [
				{ "name" : "productCode" , "value" : "รหัสสินค้า", "colspan" : "1" },
				{ "name" : "productName" , "value" : "สินค้า", "colspan" : "3" },
				{ "name" : "productWeight" , "value" : "น้ำหนัก/เส้น", "colspan" : "1" },
				{ "name" : "stockQuantity" , "value" : "จำนวน(เส้น)", "colspan" : "1" },
				{ "name" : "pricePerWeight" , "value" : "ราคา/กก.", "colspan" : "1" },
				{ "name" : "sellingPrice" , "value" : "ราคา/เส้น", "colspan" : "1" },
        { "name" : "stockDays" , "value" : "อายุสินค้า", "colspan" : "1" },
        // { "name" : "campaignStart" , "value" : "เริ่มแคมเปญ", "colspan" : "2" },
        { "name" : "campaignEnd" , "value" : "สิ้นสุดแคมเปญ", "colspan" : "2" },
			],         
      excelMeta: [
        [{
          "key": "charset",
          "value": "utf-8"
        }]
      ],  
      sizes: [],
      selectedSize: "All",  
      selectedProductsAll: false,
      action:"",
      priceType:"piece",
      checkPriceType:true,
      categoryShow:true        
    };
  },
  mounted() {
    setCurrentPageBreadcrumbs("สต็อกและราคา", ["สินค้า"]);

    this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
        });
    })

    // if(this.isAdmin) {
    //   this.getPartner(this.partnerCode)
    // }

    this.getCategoryList();
    
    this.getStock();

		var now = new Date().getTime();
		this.excelFileName = this.isAdmin ? 'Stock_'+this.partnerCode+'_'+now : 'Stock_'+now;     
    this.excelTitleSheet = 'stock ณ วันที่ : ' + DateTime.fromJSDate (this.currentDate).toFormat('dd/MM/yyyy') + ' / เวลา : ' + DateTime.fromJSDate (this.currentDate).toFormat('HH:mm');
        
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser
    },
    isAdmin() {      
      return this.$store.getters.isAdmin
    },
    showProfit() {
      return validateRole(['admin', 'owner', 'manager'])
    },
    tableHeight() {
      return this.windowHeight - 290
    },
    partnerCode() {
      return this.$store.getters.getRepresentId
    },
    // height( ) {
    //   return window.innerHeight
    // },
    page() {
      return this.$route.query.page || 1;
    },
    tableProducts() {
      return this.products.filter(
        (product) =>
          ( product.productName.match(new RegExp(this.search ? this.search.trim() : '', "i")) ||
          product.productCode.match(new RegExp(this.search ? this.search.trim() : '', "i")) || 
          product.productCategoryName.match(new RegExp(this.search, "i")) ) && (!this.selectedCategory || product.productCategoryID == this.selectedCategory.productCategoryCode)
          && (product.prosizeGroup == (this.selectedSize.trim() != "All" ? this.selectedSize.trim() : product.prosizeGroup))
      );
    },
    btnExcelClass() {
      return this.products.length==0 ? "btn btn-light-success btn-sm py-3 px-5 me-3 disabled" : "btn btn-light-success btn-sm py-3 px-5 me-3";
    },
    btnExcelStyle() {
      return this.products.length==0 ? "pointer-events:none;" : "";
    },
    countProductSelected(){
      return this.products.filter((p) => p.isSelected == true).length;
    },
    productStockZero(){
      return this.products.filter((p) => p.stockQuantity == 0 && p.isSelected == true);
    },
    productHasStock(){
      return this.products.filter((p) => p.stockQuantity > 0 && p.isSelected == true);
    },
    productNoPrice(){
      return this.products.filter((p) => p.pricePerWeight == 0 && p.isSelected == true);
    },
  },
  methods: {   
    setColumn(){
        if(this.categoryShow){
          this.categoryShow=false;
          
        }else{
          this.categoryShow=true;
        }
    }, 
    getCategoryList: async function() {
      try {
          // console.log(this.currentUser)
        const { data } = await ApiService.query("productcategorys/partner")

        this.productCategoryList = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getStock: async function () {
      this.isLoading = true;
      try {
        const { page } = this;
        const { data } = await ApiService.query("products", {
          params: { page, partnerCode: this.partnerCode, StockZero: this.checkState },
        });

        this.products = data;

      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    // getPartner: async function(partnerCode) {
    //   const {data} = await ApiService.get("partners", this.partnerCode) 
    //   this.partner = data
    //   // setCurrentPageBreadcrumbs("สต็อกและราคา (" + this.partner.partnerName + ")", ["ทะเบียนพาร์ทเนอร์"]);      
    // },
    tableSetMaginItemClickHandler: function (index, row) {
      // this.$refs.addMarginModal.show();
      this.showMarkupModal([row]);
    },
    setMarkupClickHandler() {
      // console.log(this.tableProducts.filter((p) => p.isSelected == true))
      this.showMarkupModal(this.products.filter((p) => p.isSelected == true));
    },
    showMarkupModal(products) {
      // console.log(products)
      this.$refs.addMarginModal.show(products);
    },
    selectProductAllHandler(){
      let product = this.tableProducts
      product.forEach(p => p.isSelected = this.selectedProductsAll);
    },
    selectProductHandler(val) { 
      this.selectedProducts = val;         
    },
    tableOrderClickHandeler(index, row) {
      this.order([row]);
    },
    orderClickHandler() {

      

      let productName = [];
      this.productStockZero.forEach((column, index) => {
        productName.push(column["productName"]+"\n");
      });      

      if(this.productStockZero.length == 0){
        //this.action = "order";
        this.order(this.products.filter((p) => p.isSelected == true));
      }else{
        Swal.fire({
          icon: "warning",
          title: "ไม่สามารถทำรายการได้",
          html: "<pre>" + productName.join(",").replace(",","") + "\nมีสต็อกสินค้า = 0" + '</pre>',
          customClass: {
            popup: 'format-pre'
          }          
        });        
      } 
    },
    order(products) {
      this.$router.push({
        name: "createOrder",
        query: { prods: products.map((p) => p.productID)},
      });
      // this.$router.push("/order/create?products")
    },
    returnClickHandler() {
      this.returnProducts(this.tableProducts.filter((p) => p.isSelected == true));
    },
    returnProducts(products) {
      this.$router.push({
        name: "returnProduct",
        query: { prods: products.map((p) => p.productID) },
      });
    },
    navigateToSetProduct() {
      this.$router.push({name: "setProductPartner" , params: { partnerCode: this.partnerCode } })
    },
    navigateToCreateCampaign() {
      let productTemp = this.products.filter((p) => p.isSelected == true);
      this.$router.push({name: "createCampaign",query: { prods: productTemp.map((p) => p.productID)}, params: { partnerCode: this.partnerCode} } )
    },
    numberWithCommas,
    formatDateFromISO,
    validateRole,
    canSelectRow(row, index) {
      return this.isAdmin ? true : (row.pricePerWeight > 0 && row.stockQuantity > 0);
    },
    callCustomerPartner(){
      this.$router.push({ name: "setpartner" });
    },
    handleCheckAllChange(val) {
      if(this.checkState == 1)
      {
        this.checkState = 2;
        this.checkAll = false;
        this.isIndeterminate = false;
        this.checkName = "สต็อก = 0"
        this.getStock();
      }
      else if(this.checkState == 2)
      {
        this.checkState = 3;
        this.checkAll = false;
        this.isIndeterminate = true;
        this.checkName = "สต็อกทั้งหมด"
        this.getStock();
      }
      else if(this.checkState == 3)
      {
        this.checkState = 1;
        this.checkAll = true;
        this.isIndeterminate = false;
        this.checkName = "สต็อก > 0" 
        this.getStock();
      }
    },
    handlePriceViewChange(){
      // console.log(this.checkPriceType)
        if(!this.checkPriceType){
          this.priceType = "weight";
          this.priceView = "กก."
        }else{
          this.priceType = "piece";
          this.priceView = "เส้น";
          
        }
    },
    selectCategoryHandler(category) {
      this.selectedCategory = this.selectedCategory && this.selectedCategory.productCategoryCode == category.productCategoryCode ? null : category
      this.selectedProductsAll = ((this.tableProducts.length == 0) || (this.tableProducts.filter((p) => p.isSelected == false).length > 0)) ? false : true;
      this.getSize(this.selectedCategory && this.selectedCategory.productCategoryCode == category.productCategoryCode ? category.productCategoryCode : null);
    },
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {
        if(index === 1) {
          sums[index] = data.length + ' รายการ';
        }

        
        if(col.property == "stockQuantity") {
          let totalWeight =  data.reduce(
            (prev, curr) => {
              return prev + (curr.stockQuantity * curr.productWeight) //curr[col.property]
            },
            0
          )
          //  console.log(totalWeight)
          sums[index] = "นน.รวม " + numberWithCommas(Math.round(totalWeight / 10) / 100, 2) + " ตัน";
        }
      })    
      return sums;
    },
    sellRequestClickHandler() {       

      let productNameHasStock = [];
      let productNameNoPrice = [];
      let contentText = "";
      this.productHasStock.forEach((column, index) => {
        productNameHasStock.push(column["productName"]+"\n");
      }); 
      this.productNoPrice.forEach((column, index) => {
        productNameNoPrice.push(column["productName"]+"\n");
      });  
      
      //this.sellRequestCreate(this.products.filter((p) => p.isSelected == true));
      if(this.productNoPrice.length ==0){ //this.productHasStock.length == 0&&
        //this.action = "sellrequest";
        this.sellRequestCreate(this.products.filter((p) => p.isSelected == true));
      }else{
          if(this.productNoPrice.length>0){
            contentText =  productNameNoPrice.join(",").replace(",","") + "\nยังไม่กำหนดราคา";

          }
          // if(this.productHasStock.length>0){
          //   contentText += productNameHasStock.join(",").replace(",","") + "\nมีสต๊อกสินค้ามากกว่า 0";
          // }

          Swal.fire({
            icon: "warning",
            title: "ไม่สามารถทำรายการได้",
            html: "<pre>" + contentText + '</pre>',
            customClass: {
              popup: 'format-pre'
            }          
          });    
      }
      
      
    
      
    },
    sellRequestCreate(products) {
        // console.log("products",products);
        this.$router.push({
          name: "sellrequestCreate",
          query: { prods: products.map((p) => p.productID) },
        });
    },
    transferBookClickHandler() {
      this.transferBook(this.products.filter((p) => p.isSelected == true));
    },
    transferBook(products) {
      this.$router.push({
        name: "transferbookcreate",
        query: { prods: products.map((p) => p.productID) },
      });
    },
    callProductMoveMentAllMonthModal(product){
        product.partnerCode = this.partnerCode;
        this.selectedProduct = product;
        this.$refs.productMoveMentAllMonthModal.clearData();
        this.$refs.productMoveMentAllMonthModal.show(product);
      
    },
    getSize(category) {
        ApiService.get("categories/" + category + "/sizes")
            .then( res => {
            this.sizes = res.data
            })
            .catch(() => {          
            this.$swal('error', 'error', 'error')
        })    
        this.selectedSize = "All";
    },   
    selectedSizeHandler(sizename){
        this.selectedSize = sizename;   
        // console.log(sizename);
    },     
    getPriceQuanPerPack(product){
      return product.priceQuanPerPack + " เส้น/มัด";
    },  
    getPlanFinDate(product){
      return "แผนผลิต: " + formatDateFromISO(product.planFinDate);
    },    
    clearProductSelected(){
      let products = this.products;
      products.forEach(p => p.isSelected = false);      
    },   
  },
};
</script>
<style>
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #606266;
  }
  .format-pre pre {
    font-size: 16px;
  }  
  .SelectSize {
      background-color: #007bff;
      border: solid #007bff 2px;
      color: white;
  }  
  .NotSelectSize {
      background-color: #c0c4cc59;
      border: solid #c0c4cc59 2px;
      color: black;
  }  
</style>
